import Vue from 'vue';
const ActividadesMarkerEventBus = new Vue();
export const actividadesMarkerEvents = {
  seleccionarActividad: 'seleccionarActividad',
};

export default ActividadesMarkerEventBus;
